import * as THREE from 'three';
import { BinaryInstancedSurface } from '../../rendering/binary/BinaryInstancedSurface.js';

/**
 * Binary road surface (single instanced glyph grid, one draw call).
 */
export class Road {
  /**
   * @param {{
   *   material: import('../../rendering/binary/BinaryMaterial.js').BinaryMaterial;
   *   centerX: number;
   *   centerZ: number;
   *   width: number;
   *   depth: number;
   *   cellsPerMeter: number;
   *   seed: number;
   *   cellIdBase: number;
   *   elevation?: number;
   * }} options
   */
  constructor({
    material,
    centerX,
    centerZ,
    width,
    depth,
    cellsPerMeter,
    seed,
    cellIdBase,
    elevation = 0.012,
  }) {
    this.group = new THREE.Group();
    this.group.name = 'Road';

    this.surface = new BinaryInstancedSurface({
      material,
      width,
      height: depth,
      cellsPerMeter,
      center: new THREE.Vector3(centerX, elevation, centerZ),
      normal: new THREE.Vector3(0, 1, 0),
      tangentU: new THREE.Vector3(1, 0, 0),
      tangentV: new THREE.Vector3(0, 0, -1),
      seed,
      cellIdOffset: cellIdBase,
    });

    this.cellsUsed = this.surface.instanceCount;
    this.maxColumns = this.surface.columns;
    this.group.add(this.surface.mesh);
  }

  dispose() {
    this.surface.dispose();
    this.group.clear();
  }
}
